import React from "react";

export const Page4English = () => {
  return (
    <div className="page-container">
      {" "}
      <p>
        The shrine of Kolapadu village Ayyanar temple faces west unlike other
        places. Its special feature is that within a short distance from Ayyanar
        temple, there is a temple where Shiva and Vishnu reside. This structure
        is said to be that Ayyanar gives darshan to the devotees while having
        darshan of his father and mother. The renovation has been done in a
        special way and the Kumbabhishekam has also been performed.
      </p>
      <h1>
        The history of the appearance of Adhiyannan sitting in the temple and
        blessing the devotees:
      </h1>
      <h1>The glorious Adhiyannan:</h1>
      <p>
        It is a temple located in the east direction. Since people worshiped
        Adhiyannan in the beginning, he was created by the grace of Adhi Shakti,
        and he was the eldest of all the village deities worshipped by the
        people, such as Adhiyannan, Muneeswaran, Veeran, Kathavarayan,
        Karuppannaswamy. The proof that the people of this village have been
        worshipping Adhiyannan for a long time and have benefited from it is
        that many of the villagers are named Adhiyappan and Adhiyammal.
      </p>
      <p>
        In the very first song of the Thirukkural, the phrase "Adhi Bhagavan
        mutattre ulaku" comes - thus the word Adhi is a word that gives grace.
        It is a word full of glory. Originally a clay idol, it was transformed
        into a stone idol when the temple was built and consecrated a few years
        ago. Currently, a stone idol has been constructed at great expense using
        wire cement and a high-quality mixture and is being placed behind the
        previous idol in the sanctum sanctorum for worship and is being blessed
        by Adhiyannan.
      </p>
      <p>
        The temple and the tower have been built, new kalasams have been
        installed, and they are painted and look very bright. Everyone come and
        worship Adhiyannan!
      </p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>Receive blessings!! </p>
        <p>Live with prosperity!!!</p>
      </div>
      <h1>
        Sri Ayyanar
        <br />
        Sri Adhiyannan located in Kolapadu village
      </h1>
      <p>
        The temples were renovated and the Kumbabhishekam was conducted very
        well by the Bangalore businessman and Tirupani Chemmal S. Durairaj, who
        has received the blessings of Sri Ayyanar, Sri Adhiyannan and the
        appreciation of the villagers and devotees
      </p>
    </div>
  );
};
